import { css } from 'lit';
export const hero = css `
    :host {
        display: block;
        padding: var(--spacing-xxxxl) 0;
        background-color: var(--color-ui-08);
        background-repeat: no-repeat;
        background-image: var(--service-and-contact-hero-bg-url);
    }

    :host([form-factor='mobile']) {
        padding-block-start: calc(200px + var(--spacing-l));
        background-size: auto 200px;
        background-position: top center;
    }

    :host([form-factor='tablet']),
    :host([form-factor='desktop']) {
        background-size: cover;
    }

    :host([form-factor='tablet']) .search,
    :host([form-factor='desktop']) .search {
        background-color: var(--color-ui-08);
        padding: var(--spacing-xxxxl);
        max-width: 600px;
    }

    .input {
        min-width: 18em;
        flex: 1;
    }

    .submit {
        flex-shrink: 0;
    }
`;
export const popularTopics = css `
    :host {
        display: block;
        padding: var(--spacing-xxxxl) 0;
        background-color: var(--color-ui-07);
    }

    .label {
        padding: var(--spacing-l);
    }
`;
export const links = css `
    :host {
        display: block;
        padding: var(--spacing-xxxxl) 0;
        background-color: var(--color-ui-08);
    }

    .link-blocks {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(20em, 1fr));
        gap: var(--spacing-xxxxl);
    }
`;
export const linksBlock = css `
    .list-item {
        --list-item-icon-color: var(--color-support-01);
        --list-item-align-items: baseline;
    }

    :host([form-factor='mobile']) .list {
        display: block;
        margin-inline-start: calc(var(--icon-size-m) + var(--spacing-l));
    }

    .trigger-icon {
        transition: var(--transition-speed-slow) var(--ease-in-out-quart);
    }

    .trigger-icon[data-is-active] {
        transform: rotate(180deg);
    }
`;
export const usps = css `
    :host {
        display: block;
        padding: var(--spacing-xxxxl) 0;
        background-color: var(--color-support-02);
    }

    :host([form-factor='desktop']) .heading {
        max-width: 7em;
    }

    .list {
        display: block;
        flex: 1;
    }

    :host([form-factor='desktop']) .list-content {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(12em, max-content));
    }

    .list-item {
        --list-item-align-items: flex-start;
    }

    .digid-asset {
        aspect-ratio: 1;
        filter: drop-shadow(white 1px 0px 0px) drop-shadow(white -1px 0px 0px) drop-shadow(white 0px 1px 0px)
            drop-shadow(white 0px -1px 0px);
        width: 3em;
    }
`;
export const contactOptions = css `
    :host {
        display: block;
        padding: var(--spacing-xxxxl) 0;
        background-color: var(--color-ui-07);
    }

    .card {
        padding: var(--spacing-xl);
    }

    .link {
        --icon-color: var(--color-support-01);
        --button-text-align: left;
        --button-label-whitespace: normal;
    }
`;
export const layout = css `
    .grid {
        --grid-column-min: 200px;

        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(var(--grid-column-min), 1fr));
    }

    .grid-col {
        grid-template-columns: 1fr;
    }
`;
